import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { RaiseSupportTicketComponent } from "src/app/shared/components/raise-support-ticket/raise-support-ticket.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-support-ticket-details",
  templateUrl: "./support-ticket-details.component.html",
  styleUrls: ["./support-ticket-details.component.scss"],
})
export class SupportTicketDetailsComponent implements OnInit,OnDestroy {
  loader: boolean = false;
  selectedTicket:any
  supportTicketDetails: any = [];
  apisub: Subscription
  public page: number = 1;
  datalength!: number;
  constructor(
    private _navservice: NavigationService,
    private apiservice: ApiService,
    private route: ActivatedRoute,
    private loaderservice: LoaderServiceService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this._navservice.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_SUPPORT_THREAD){
        this.supportTicketDetails = []

        if(resdata.result){
          this.datalength = resdata.result ? resdata.result[0].total_results : 0;
          this.supportTicketDetails = resdata.result
          this.supportTicketDetails.forEach((element:any) => {
            element.uploads = typeof element.uploads == 'string' ? JSON.parse(element.uploads) : element.uploads
            const index = element.uploads.findIndex((item:any) => item.img_url == null);
            if (index !== -1) {
              element.uploads.splice(index, 1);
          }
            
          });
        }
        console.log(this.supportTicketDetails);
        
        this.loader=false
        this.loaderservice.showLoader = false
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_SET_SUPPORT_TICKET_STATUS){
        if(resdata.result){
          this.route.queryParams.subscribe((data) => {
            console.log(data.ticketHash);
            if(this.currentStatus == 6){
              this.loader = false
              this.loaderservice.showLoader = false
              const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash };
              this.router.navigate(['../'], { queryParams, relativeTo: this.route });
            }
            else{
              this.apiservice.getSupportThread(data.ticketHash, this.page.toString())

            }
          });
        }
      }
    })
  }

  ngOnInit(): void {
    this.selectedTicket = typeof sessionStorage.getItem('selectedTicket') == 'string' ? JSON.parse(sessionStorage.getItem('selectedTicket')!) : sessionStorage.getItem('selectedTicket')
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.ticketHash);
      this.apiservice.getSupportThread(data.ticketHash, this.page.toString())
    });
  }

  extractFileName(url:any) {
    // Split the URL by '/' and get the last part
    const parts = url.split('/');
    return parts[parts.length - 1];
  }
  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
  sendSupportQueryResponse(){
    let dialogref = this.dialog.open(RaiseSupportTicketComponent,{
      width: '600px',
      data:{
        title: 'Reply Support Query',
        ref: this.dialog,
        data: this.supportTicketDetails[0].support_hash
      }
    })

    dialogref.afterClosed().subscribe(res =>{
      if(res){
          this.ngOnInit()
      }
    })
  }
  currentStatus: any;
  setserviceStatus(status:any){
    this.currentStatus = status
    if(status == 1){
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
        data : {
          title : 'Alert',
          message : 'Are you sure you want to mark this ticket as resolved?',
          okbtn : 'Confirm',
          cancelbtn : 'Cancel',
          type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
        },
        disableClose : true
      });
      dialogRef.afterClosed().subscribe(result=>{
        console.log(result);
        if(result){ 
          let data = {
            "ticket_hash": this.selectedTicket.hash_id, 
            "status": status
            }
          this.loaderservice.showLoader  = true
          this.loader = true
          this.selectedTicket.resolve_status = status
          sessionStorage.setItem("selectedTicket", JSON.stringify(this.selectedTicket));
          this.apiservice.setSupportTicketStatus(data)
        }
      
    })
    }
    else if(status == 0){
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
        data : {
          title : 'Alert',
          message : 'Are you sure you want to mark this ticket as opened?',
          okbtn : 'Confirm',
          cancelbtn : 'Cancel',
          type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
        },
        disableClose : true
      });
      dialogRef.afterClosed().subscribe(result=>{
        console.log(result);
        if(result){ 
          let data = {
            "ticket_hash": this.selectedTicket.hash_id, 
            "status": status
          }
          this.loaderservice.showLoader  = true
          this.loader = true
          this.selectedTicket.resolve_status = status
          sessionStorage.setItem("selectedTicket", JSON.stringify(this.selectedTicket));
          this.apiservice.setSupportTicketStatus(data)
        }
      
    })
    }
    else if(status == 6){
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
        data : {
          title : 'Alert',
          message : 'Are you sure you want to delete this ticket?',
          okbtn : 'Confirm',
          cancelbtn : 'Cancel',
          type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
        },
        disableClose : true
      });
      dialogRef.afterClosed().subscribe(result=>{
        console.log(result);
        if(result){ 
          let data = {
            "ticket_hash": this.selectedTicket.hash_id, 
            "status": status
          }
          this.loaderservice.showLoader  = true
          this.loader = true
          this.selectedTicket.resolve_status = status
          sessionStorage.setItem("selectedTicket", JSON.stringify(this.selectedTicket));
          this.apiservice.setSupportTicketStatus(data)
        }
      
    })
    }
    else if(status == 2){
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
        data : {
          title : 'Alert',
          message : 'Are you sure you want to mark this ticket as in progress?',
          okbtn : 'Confirm',
          cancelbtn : 'Cancel',
          type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
        },
        disableClose : true
      });
      dialogRef.afterClosed().subscribe(result=>{
        console.log(result);
        if(result){ 
          let data = {
            "ticket_hash": this.selectedTicket.hash_id, 
            "status": status
          }
          this.loaderservice.showLoader  = true
          this.loader = true
          this.selectedTicket.resolve_status = status
          sessionStorage.setItem("selectedTicket", JSON.stringify(this.selectedTicket));
          this.apiservice.setSupportTicketStatus(data)
        }
      
    })
    }
    else if(status == 3){
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
        data : {
          title : 'Alert',
          message : 'Are you sure you want to mark this ticket as closed?',
          okbtn : 'Confirm',
          cancelbtn : 'Cancel',
          type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
        },
        disableClose : true
      });
      dialogRef.afterClosed().subscribe(result=>{
        console.log(result);
        if(result){ 
          let data = {
            "ticket_hash": this.selectedTicket.hash_id, 
            "status": status
          }
          this.loaderservice.showLoader  = true
          this.loader = true
          this.selectedTicket.resolve_status = status
          sessionStorage.setItem("selectedTicket", JSON.stringify(this.selectedTicket));
          this.apiservice.setSupportTicketStatus(data)
        }
      
    })
    }
  }
  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this.route.queryParams.subscribe((data) => {
      console.log(data.ticketHash);
      this.apiservice.getSupportThread(data.ticketHash, this.page.toString())
    });
  }
}
